import PSA from '../../psa';
import ScrMen from '../scrmen/ScrMen';
import RchDteExt from './RchDteExt';
import ItmMgr from '../../gui/ItmMgr';
import Validator from '../../utils/Validator';

const RGX_CR = /\r/g;

export default class RchTxtWdg {

	constructor(cbw, idw, wdg, cfg) {
		this.cbkWdg = cbw;
		this.wdgId = idw;
		this.txtWdg = wdg;
		this.mulLin = !!(wdg._customVariant && wdg._customVariant == "variant_txt_multiline");

		const psa = PSA.getInst();
		const sei = !!cfg.exp;
		const cmb = !!cfg.cmb;
		const dte = !!cfg.dte;
		const alignment = Validator.isString(cfg.alignment) ? cfg.alignment : 'left';

		const parent = rap.getObject(idw);
		this.parent = parent;
		if ( parent.getData("pisasales.CSTPRP.HYP") ) {
			this.hasLnk = true;
		}
		this.pntDiv = this.parent.$el.get()[0];
		this.pntDiv.classList.add("rchTxt");
		this.pntDiv.classList.add("minimized");
		if ( cmb ) {
			this.pntDiv.classList.add("cmb");
		}

		this.txtDco = '';
		this.isClk = false;
		this.mosDwnPos = null;
		this.drag = null;
		this.overlayDiv = null;
		this.counter = null;
		this.scrBarVis = false;
		this.txtLim = -1;
		this.sndEachChr = false;
		this.kprLsr = 0;
		this.clrTxt = null;
		this.clrBkg = null;
		this.noRetKey = false;
		this.drpDwnID = null;
		this.drpDwnBtn = null;
		this.readOnly = null;
		this.expandIco = null;
		this.alignment = alignment;

		this.txtWdg.addEventListener("mousedown", this._onMouseDown, this);
		this.txtWdg.addEventListener("mouseup", this._onMouseUp, this);
		this.txtWdg.addEventListener("mousemove", this._onMouseMove, this);
		this.txtWdg.addEventListener("mouseleave", this._onMouseLeave, this);
		this.txtWdg.addEventListener("input", this._onInput, this);
		this.txtWdg.addEventListener("keypress", this._onKeyPress, this);
		this.txtWdg.addEventListener("click", this._onClick, this);
		if ( sei ) {
			this.txtWdg.addEventListener("focus", this._onFocus, this);
			this.txtWdg.addEventListener("blur", this._onBlur, this);
		}
		this.curSel = [ 0, 0 ];
		this.inRstSel = false;
		this.txtWdg.addEventListener("selectionChanged", this._onSelChange, this);
		const self = this;
		const inp = wdg._inputElement;
		if ( inp ) {
			inp.addEventListener("paste", function(evt) {
				self._onPaste(evt, inp);
			});
		}
		this.sndChk = true;
		this._dirty = false;
		this._linkActive = false;
		this._mouseDown = false;
		this.dteExt = dte ? new RchDteExt(this) : null;
	}

	destroy() {
		if ( this.dteExt ) {
			const ext = this.dteExt;
			this.dteExt = null;
			ext.destroy();
		}
		this.txtWdg.removeEventListener("keypress", this._onKeyPress, this);
		this.txtWdg.removeEventListener("input", this._onInput, this);
		this.txtWdg.removeEventListener("click", this._onClick, this);
		this.txtWdg.removeEventListener("mousemove", this._onMouseMove, this);
		this.txtWdg.removeEventListener("mouseleave", this._onMouseLeave, this);
		this.txtWdg.removeEventListener("focus", this._onFocus, this);
		this.txtWdg.removeEventListener("blur", this._onBlur, this);
		this.txtWdg.removeEventListener("mousedown", this._onMouseDown, this);
		this.txtWdg.removeEventListener("mouseup", this._onMouseUp, this);
		this.drpDwnID = null;
		this.drpDwnBtn = null;
		this.cbkWdg = null;
		this.wdgId = null;
		this.txtWdg = null;
		this.mulLin = null;
		this.pntDiv = null;
		this.clrTxt = null;
		this.clrBkg = null;
		this.parent = null;
	}

	getRapWdg() {
		return this.parent;
	}

	getTxtWdg() {
		return this.txtWdg;
	}

	wdgUpd(args) {
		this.sndChk = !!args.chk;
		if ( !!args.clear ) {
			this._dirty = false;
		}
		if ( this._isNoWrap() ) {
			this.txtWdg._element.classList.add("no-wrap");
		}
		this.noRetKey = this._isNoReturn();
	}

	wdgInfo(args) {
		if ( this.txtWdg && (this.txtWdg._element instanceof HTMLElement) ) {
			const element = this.txtWdg._element;
			const info = args.info || {};
			const psa = PSA.getInst();
			const fmt_dsc = info.fmtDsc || '';
			if ( Validator.isString(fmt_dsc) ) {
				element.dataset.testFmtDsc = fmt_dsc;
			}
			const java_dsc = info.javaDsc || '';
			if ( Validator.isString(java_dsc) ) {
				element.dataset.testJavaDsc = java_dsc;
			}
			const type_id = info.dataTypeID || '';
			if ( Validator.isString(type_id) ) {
				element.dataset.testDataTypeId = type_id;
			}
			const type_name = info.dataTypeName || '';
			if ( Validator.isString(type_name) ) {
				element.dataset.testDataTypeName = type_name;
			}
		}
	}

	wdgGui(args) {
		if ( this.txtWdg && this.txtWdg._inputElement ) {
			if ( this._isNoWrap() ) {
				this.txtWdg._element.classList.add("no-wrap");
			}
			this.noRetKey = this._isNoReturn();
			const mgr = ItmMgr.getInst();
			let tdc = this.txtDco;
			let paddingRight = '';
			let overflow = '';
			const data = args.data || null;
			if ( data ) {
				if ( data.drpDwnID && !this.drpDwnID ) {
					this.drpDwnID = data.drpDwnID;
					this._setDrpDwnBtn();
				}
				if ( data.fnt ) {
					if ( data.fnt.tdc ) {
						tdc = data.fnt.tdc;
						if ( tdc === '$NONE' ) {
							tdc = '';
						}
					}
				}
				if ( data.fgrClr ) {
					mgr.setFgrClr(this.txtWdg._inputElement, data.fgrClr);
					this.clrTxt = data.fgrClr;
				}
				if ( data.bkgClr ) {
					if ( this.txtWdg._inputElement.parentNode ) {
						let bgc = data.bkgClr;
						mgr.setBkgClr(this.txtWdg._inputElement.parentNode, bgc, true);
						if ( bgc instanceof Array ) {
							const ths = 250;
							const a = bgc.length > 3 ? bgc[3] : 255;
							if ( (bgc[0] >= ths) && (bgc[1] >= ths) && (bgc[2] >= ths) && (a > 127) ) {
								bgc = null;
							}
						}
						this.clrBkg = bgc;
					}
				}
				if ( data.cssSty ) {
					if ( data.cssSty.paddingRight || data.cssSty.paddingRight === 0 ) {
						paddingRight = data.cssSty.paddingRight;
					}
					if ( data.cssSty.overflow ) {
						overflow = data.cssSty.overflow;
					}
				}
				if ( typeof data.readOnly === 'boolean' ) {
					this.readOnly = !!data.readOnly;
					this._updateExpandButton();
				}
				if ( (typeof data.txtLim === 'number') && (data.txtLim > 0) ) {
					this.txtLim = data.txtLim;
				}
				if ( (typeof data.sndEachChr === 'number') ) {
					const snd = (data.sndEachChr > 0) || false;
					this.sndEachChr = snd;
				}
				if ( typeof data.setKprLsr === 'number' ) {
					this.kprLsr = data.setKprLsr;
				}
				if ( typeof data.cssInfo === 'object' ) {
					const cssInfo = data.cssInfo;
					const cssClass = cssInfo.cssClass || '';
					if ( cssClass.length > 0 ) {
						const elm = this.txtWdg._element;
						if ( elm instanceof HTMLElement ) {
							if ( cssInfo.mark ) {
								elm.classList.add(cssClass);
							} else {
								elm.classList.remove(cssClass);
							}
						}
					}
				}
			}
			const elm = this.txtWdg._inputElement;
			if ( elm ) {
				elm.style.textDecoration = tdc;
				if ( paddingRight || paddingRight === 0 ) {
					elm.style.paddingRight = paddingRight + 'px';
					if ( paddingRight === 0 ) {
						this.pntDiv.classList.remove('cmbfoc');
					} else {
						this.pntDiv.classList.add('cmbfoc');
					}
				}
				if ( overflow ) {
					elm.style.overflow = overflow;
				}
			}
			this.txtDco = tdc;
		}
	}

	wdgAct(args) {
		if ( !this.parent || !this.txtWdg ) {
			return false;
		}
		let hdl = false;
		if ( this.dteExt ) {
			hdl = this.dteExt.wdgAct(args);
		}
		if ( !hdl ) {
			const data = args.data || {};
			const act = data.act || '';
			if ( Validator.isString(act) ) {
				switch ( act ) {
					case 'sel':
						const beg = data.beg;
						const end = data.end;
						if ( (typeof beg === 'number') && (typeof end === 'number') ) {
							try {
								const wdg = this.getRapWdg();
								if ( wdg ) {
									const sel = [ beg, end ];
									this.txtWdg.setSelection(sel);
									if ( beg === 0 ) {
										const inp = wdg.$input.get()[0];
										if ( inp && (typeof inp.scrollTo === 'function') ) {
											inp.scrollTo(0, 0);
										}
									}
								}
							} catch ( err ) {
								console.warn(err);
							}
							this.curSel = this.txtWdg.getSelection();
						}
						hdl = true;
						break;
					case 'upd':
						const txt = data.txt || '';
						if ( this.overlayDiv ) {
							const inp = this.overlayDiv.__input_elm || null;
							if ( inp ) {
								inp.value = txt;
							}
						}
						hdl = true;
						break;
					default:
						break;
				}
			}
		}
		return hdl;
	}

	getKprLsr() {
		return this.kprLsr;
	}

	_isNoWrap() {
		const userData = this.txtWdg.getUserData("org.eclipse.swt.widgets.Widget#data");
		if ( userData ) {
			if ( "no-wrap" === userData["pisasales.CSTPRP.CWD"] ) {
				return true;
			}
		}
		return false;
	}

	_isNoReturn() {
		const userData = this.txtWdg.getUserData("org.eclipse.swt.widgets.Widget#data");
		if ( userData ) {
			if ( "no-return" === userData["pisasales.CSTPRP.CWD"] ) {
				return true;
			}
		}
		return false;
	}

	_maximize() {
		const self = this;

		self._blockKeyHandling(true);

		if ( this.overlayDiv == null ) {
			const isMasked = this.txtWdg._inputElement.type === "password";
			this.overlayDiv = this.createOverlayDiv(isMasked);
		}
		document.body.appendChild(this.overlayDiv);
		const overlayTextArea = this.overlayDiv.childNodes[0];

		document.documentElement.addEventListener("mousedown", self.omdaFct = function(evt) {
			self._onMouseDownAnywhere(evt);
		});

		document.documentElement.addEventListener("keydown", self.escFct = function(evt) {
			self._onKeyPressMinimize(evt);
		});

		const bounds = this.txtWdg._element.getBoundingClientRect();

		this.originalBounds = {
			x1: bounds.left,
			y1: bounds.top,
			x2: bounds.left + bounds.width,
			y2: bounds.top + bounds.height
		};

		this.perspectiveDimensions = {
			width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
			height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
		};

		this.overlayDiv.classList.add("rchTxt");
		this.overlayDiv.classList.add("maximized");

		const mgr = ItmMgr.getInst();
		overlayTextArea.style.cssText = this.txtWdg._inputElement.style.cssText;
		if ( this.clrBkg ) {
			mgr.setBkgClr(overlayTextArea, this.clrBkg, true);
		} else {
			const bgc = this.parent.getData("pisasales.CSTPRP.HVR");
			if ( bgc ) {
				mgr.setBkgClr(overlayTextArea, bgc, true);
			}
		}
		this.overlayDiv.style.cssText = this.txtWdg._element.style.cssText;

		this.overlayDiv.style.left = this.originalBounds.x1 + "px";
		this.overlayDiv.style.top = this.originalBounds.y1 + "px";
		this.overlayDiv.style.width = this.originalBounds.x2 - this.originalBounds.x1 + "px";

		this._setInitialState(this.overlayDiv);

		overlayTextArea.value = this.txtWdg._inputElement.value;

		overlayTextArea.readOnly = this.txtWdg.isReadOnly();

		const maxLength = this.txtWdg.getMaxLength();
		if ( maxLength != null ) {
			overlayTextArea.setAttribute("maxlength", maxLength);
		}

		const splitString = overlayTextArea.value.split(/\s+/);
		let longestString = "";
		for ( let i = 0; i < splitString.length; i++ ) {
			if ( splitString[i].length > longestString.length ) {
				longestString = splitString[i];
			}
		}

		const font = overlayTextArea.style.fontSize + " " + overlayTextArea.style.fontFamily;
		let newWidth = this._getTextWidth(longestString, font) + 25;
		if ( newWidth < this.originalBounds.x2 - this.originalBounds.x1 ) {
			newWidth = this.originalBounds.x2 - this.originalBounds.x1 + 15;
		}

		if ( (newWidth + this.originalBounds.x1) > this.perspectiveDimensions.width ) {
			if ( newWidth > this.perspectiveDimensions.width ) {
				this.overlayDiv.style.left = "0px";
				newWidth = this.perspectiveDimensions.width;
			} else {
				this.overlayDiv.style.left = (this.perspectiveDimensions.width - newWidth) + "px";
			}
		}
		this.overlayDiv.style.width = newWidth + "px";

		let newHeight = overlayTextArea.scrollHeight + 30;
		if ( (newHeight + this.originalBounds.y1) > this.perspectiveDimensions.height ) {
			if ( newHeight > this.perspectiveDimensions.height ) {
				this.overlayDiv.style.top = "0px";
				newHeight = this.perspectiveDimensions.height;
			} else {
				this.overlayDiv.style.top = (this.perspectiveDimensions.height - newHeight) + "px";
			}
		}
		this.overlayDiv.style.height = newHeight + "px";

		const inputStyle = this.txtWdg._inputElement.style;
		overlayTextArea.style.paddingTop = inputStyle.top == null ? "0px" : inputStyle.top;
		overlayTextArea.style.paddingRight = inputStyle.right == null ? "0px" : inputStyle.right;
		overlayTextArea.style.paddingLeft = inputStyle.left == null ? "0px" : inputStyle.left;
		overlayTextArea.style.paddingBottom = inputStyle.bottom == null ? "0px" : inputStyle.bottom;

		overlayTextArea.focus();
		if ( !!maxLength ) {
			this._initOverlayCounter(overlayTextArea.value.length, maxLength);
		}

		this.overlayDiv.addEventListener("mousemove", this.pntHvrFct = function(evt) {
			self._onHover(evt);
		});

		overlayTextArea.addEventListener("input", this.overlayInputFct = function(evt) {
			if ( self.counter != null ) {
				self.counter.currentSize = overlayTextArea.value.length;
			}
			self._updateOverlayCounter();
			self.txtWdg.setValue(overlayTextArea.value);
			self._onInput(evt);
		});
	}

	_hasOverlayDiv() {
		return !!this.overlayDiv;
	}

	_getTextWidth(text, font) {
		const canvas = document.createElement("canvas");
		const context = canvas.getContext("2d");
		context.font = font;
		const metrics = context.measureText(text);
		return metrics.width;
	}

	_initOverlayCounter(currentSize, limit) {
		this.counter = {
			_element: document.createElement("div"),
			currentSize: currentSize,
			limit: limit
		};
		this.counter._element.innerHTML = this.counter.currentSize + " / " + this.counter.limit;
		this.counter._element.setAttribute("class", "counter");
		this.overlayDiv.appendChild(this.counter._element);
	}

	_updateOverlayCounter() {
		if ( this.counter != null ) {
			this.counter._element.innerHTML = this.counter.currentSize + " / " + this.counter.limit;
		}
	}

	_destroyOverlayCounter() {
		if ( this.counter != null ) {
			this.overlayDiv.removeChild(this.counter._element);
			this.counter = null;
		}
	}

	_minimize() {
		document.documentElement.removeEventListener("mousedown", this.omdaFct);
		document.documentElement.removeEventListener("keydown", this.escFct);

		if ( this.overlayDiv != null ) {
			this._setInitialState(this.overlayDiv);
			this.overlayDiv.style.left = this.originalBounds.x1 + "px";
			this.overlayDiv.style.top = this.originalBounds.y1 + "px";
			this.overlayDiv.style.width = this.originalBounds.x2 - this.originalBounds.x1 + "px";
			this.overlayDiv.style.height = this.originalBounds.y2 - this.originalBounds.y1 + "px";

			this.overlayDiv.childNodes[0].removeEventListener("input", this.overlayInputFct);
			this.overlayDiv.removeEventListener("mousemove", this.pntHvrFct);

			const self = this;
			setTimeout(function() {
				self._destroyOverlayCounter();
				if ( !!self.overlayDiv ) {
					document.body.removeChild(self.overlayDiv);
				}
				self.overlayDiv = null;
			}, 100);
		}
		this._blockKeyHandling(false);
		if ( !!this.txtWdg && !!this.txtWdg._inputElement ) {
			this.txtWdg._inputElement.focus();
		}
	}

	_onMouseUpAnywhere(evt) {
		this._mouseDown = false;
		document.documentElement.removeEventListener("mouseup", this.omuaFct);
		const mosUpPos = {
			x: evt.clientX,
			y: evt.clientY
		};

		if ( evt.target !== this.overlayDiv && evt.target.parentNode !== this.overlayDiv && !this._isDrag() ) {
			this._minimize();
		}
	}

	_setInitialState(elm) {
		window.getComputedStyle(elm).top;
		window.getComputedStyle(elm).left;
		window.getComputedStyle(elm).width;
		window.getComputedStyle(elm).height;
	}

	_onKeyPressMinimize(evt) {
		if ( evt.which === 27 || evt.which === 9 ) {
			if ( evt.which === 27 ) {
				evt.stopPropagation();
				evt.preventDefault();
			}
			this._minimize();
		}
	}

	_onMouseDownAnywhere(evt) {
		this.mosDwnPos = {
			x: evt.clientX,
			y: evt.clientY
		};

		const self = this;

		document.documentElement.addEventListener("mouseup", self.omuaFct = function(evt) {
			self._onMouseUpAnywhere(evt);
		});

		if ( evt.target.classList.contains("maximized") || evt.target.parentNode.classList.contains("maximized") ) {
			const rect = this.overlayDiv.getBoundingClientRect();
			this.drag = {
				isLeft: Math.abs(evt.clientX - rect.left) < 6,
				isRight: Math.abs(evt.clientX - rect.right) < 6,
				isTop: Math.abs(evt.clientY - rect.top) < 6,
				isBottom: Math.abs(evt.clientY - rect.bottom) < 6
			};
			if ( this._isDrag() ) {
				const self = this;
				document.documentElement.addEventListener("mousemove", self.mosMovFct = function(evt) {
					self._onResize(evt);
				}, this);
				document.documentElement.addEventListener("mouseup", self.mosUpFct = function(evt) {
					self._onResizeMouseUp(evt);
				}, this);
			}
		}
	}

	_isDrag() {
		if ( this.drag && (this.drag.isLeft || this.drag.isRight || this.drag.isTop || this.drag.isBottom) ) {
			return true;
		} else {
			return false;
		}
	}

	createOverlayDiv(mask) {
		const overlayDiv = document.createElement("div");
		let overlayInput = null;
		if ( mask ) {
			overlayInput = document.createElement("input");
			overlayInput.setAttribute("type", "password");
		} else {
			overlayInput = document.createElement("textarea");
			overlayInput.setAttribute("type", "text");
		}

		overlayDiv.style.position = "absolute";
		overlayDiv.style.zIndex = "2147483645";
		overlayDiv.__input_elm = overlayInput;
		overlayDiv.appendChild(overlayInput);
		return overlayDiv;
	}

	_onHover(evt) {
		const rect = this.overlayDiv.getBoundingClientRect();
		const hover = {
			isLeft: Math.abs(rect.left - evt.clientX) < 6,
			isRight: Math.abs(evt.clientX - rect.right) < 6,
			isTop: Math.abs(rect.top - evt.clientY) < 6,
			isBottom: Math.abs(evt.clientY - rect.bottom) < 6
		};
		if ( hover.isRight && hover.isBottom || hover.isLeft && hover.isTop ) {
			evt.target.style.cursor = "nwse-resize";
		} else if ( hover.isLeft && hover.isBottom || hover.isRight && hover.isTop ) {
			evt.target.style.cursor = "nesw-resize";
		} else if ( hover.isLeft || hover.isRight ) {
			evt.target.style.cursor = "e-resize";
		} else if ( hover.isTop || hover.isBottom ) {
			evt.target.style.cursor = "s-resize";
		} else {
			evt.target.style.cursor = "text";
		}
	}

	_onMouseDown(evt) {
		this.mosDwnPos = {
			x: evt.getClientX(),
			y: evt.getClientY()
		};
		this._mouseDown = true;
	}

	_onResize(evt) {
		this.overlayDiv.classList.add("no_transition");
		evt.stopPropagation();
		const rect = this.overlayDiv.getBoundingClientRect();

		if ( this.drag.isLeft ) {
			if ( evt.clientX < this.originalBounds.x1 && evt.clientX > 0 ) {
				this.overlayDiv.style.width = (rect.right - evt.clientX) + "px";
				this.overlayDiv.style.left = evt.clientX + "px";
			}
		} else if ( this.drag.isRight ) {
			if ( evt.clientX > this.originalBounds.x2 && evt.clientX < this.perspectiveDimensions.width ) {
				this.overlayDiv.style.width = (evt.clientX - rect.left) + "px";
			}
		}
		if ( this.drag.isTop ) {
			if ( evt.clientY < this.originalBounds.y1 && evt.clientY > 0 ) {
				this.overlayDiv.style.height = (rect.bottom - evt.clientY) + "px";
				this.overlayDiv.style.top = evt.clientY + "px";
			}
		} else if ( this.drag.isBottom ) {
			if ( evt.clientY > this.originalBounds.y2 && evt.clientY < this.perspectiveDimensions.height ) {
				this.overlayDiv.style.height = (evt.clientY - rect.top) + "px";
			}
		}
	}

	_onResizeMouseUp(evt) {
		this.overlayDiv.classList.remove("no_transition");

		document.documentElement.removeEventListener("mousemove", this.mosMovFct, this);
		document.documentElement.removeEventListener("mouseup", this.mosUpFct, this);

		this.overlayDiv.childNodes[0].focus();

		this.drag = null;
	}

	_onMouseUp(evt) {
		this._mouseDown = false;
		const mosUpPos = {
			x: evt.getClientX(),
			y: evt.getClientY()
		};
		if ( this.isClose(this.mosDwnPos, mosUpPos) ) {
			this.isClk = true;
		}
	}

	isClose(mosDwnPos, mosUpPos) {
		return mosDwnPos && (Math.abs(mosUpPos.x - mosDwnPos.x) < 2 && Math.abs(mosUpPos.y - mosDwnPos.y) < 2);
	}

	_onInput(evt) {
		this._dirty = true;
		if ( this.sndChk ) {
			this.sndChk = false;
			const par = {};
			par.curTxt = this.txtWdg.getInputElement().value;
			this.cbkWdg.nfySrv(this.wdgId, "chkEdt", par, false);
		} else if ( this.sndEachChr ) {
			const par = {};
			par.curTxt = this.txtWdg.getInputElement().value;
			this.cbkWdg.nfySrv(this.wdgId, "fltEdtTxt", par, false);
		}
		this._checkScrollTopChange();
	}

	sndUpdSel() {
		const par = {};
		par.sel = this.txtWdg.getSelection();
		this.cbkWdg.nfySrv(this.wdgId, 'updSel', par, false);
	}

	hdlKeyPress(evt, sns) {
		if ( (this.kprLsr > 0) || this.noRetKey ) {
			let snd = false;
			const cod = evt.getKeyCode();
			let key = evt.getKeyIdentifier();
			const sft = evt.isShiftPressed();
			const ctr = evt.isCtrlPressed();
			const alt = evt.isAltPressed();
			let txt = '';
			switch ( key ) {
				case "Down":
				case "Up":
				case "Left":
				case "Right":
					snd = (this.kprLsr > 0) && !sft && !ctr && !alt;
					break;
				case "Enter":
					if ( this.noRetKey ) {
						evt.stopPropagation();
						evt.preventDefault();
						txt = this.txtWdg.getInputElement().value;
						snd = true;
					}
					break;
				default:
					if ( (this.kprLsr > 1) && !sft && !ctr && !alt ) {
						if ( key.length === 1 ) {
							if ( (('A' <= key) && (key <= 'Z')) || (('0' <= key) && (key <= '9')) || (key === '_') || (key === '.') ) {
								snd = true;
							}
						} else if ( (cod === 190) && (key === 'Unidentified') ) {
							key = '.';
							snd = true;
						}
					}
					break;
			}
			if ( snd ) {
				const par = {};
				par.kcd = cod;
				par.key = key;
				par.sft = sft;
				par.ctr = ctr;
				par.alt = alt;
				if ( sns ) {
					par.sel = this.txtWdg.getSelection();
				}
				if ( Validator.isString(txt) ) {
					par.txt = txt;
				}
				this.cbkWdg.nfySrv(this.wdgId, 'keyPress', par, false);
			}
		}
	}

	_onKeyPress(evt) {
		if ( this.dteExt ) {
			this.dteExt.hdlKeyPress(evt, false);
		} else {
			this.hdlKeyPress(evt, false);
		}
	}

	_onPaste(evt, inp) {
		if ( this.txtLim > 0 ) {
			const cur = inp.value;
			let clp = (evt.clipboardData || window.clipboardData).getData('text');
			if ( Validator.isString(clp) ) {
				clp = clp.replace(RGX_CR, '');
				if ( clp.length > 0 ) {
					const cmp = (cur || '') + clp;
					let rpl = 0;
					const sel = this.txtWdg.getSelection();
					if ( sel && (sel.length > 1) ) {
						rpl = sel[1] - sel[0];
					}
					if ( (cmp.length - rpl) > this.txtLim ) {
						const par = {};
						par.cur = cur;
						par.clp = clp;
						par.rpl = rpl;
						this.cbkWdg.nfySrv(this.wdgId, "clpLim", par, false);
					}
				}
			}
		}
	}

	_checkScrollTopChange(evt) {
		if ( this.txtWdg.getInputElement() ) {
			const isScrBarVis = this.scrBarVis
				? this.txtWdg.getInputElement().scrollTop !== 0
				: this.txtWdg.getInputElement().scrollTop === 0;
			const changed = this.scrBarVis != isScrBarVis;
			this.scrBarVis = isScrBarVis;
			if ( changed ) {
				if ( !!this.expandIco ) {
					this.txtWdg._element.removeChild(this.expandIco);
					this.expandIco = null;
				}
				this._tryShowExpandButton();
			}
		}
	}

	_setDrpDwnBtn() {
		if ( !this.drpDwnID ) return;
		const btn = this.drpDwnBtn ||
			rwt.remote.ObjectRegistry.getObject(this.drpDwnID);
		if ( !btn || typeof btn != "object" ) return;
		btn.addEventListener("click", this._onDrpDwnBtnMouseUpDownClick, this);
	}

	_onDrpDwnBtnMouseUpDownClick(evt) {
		return this._blurAllEditors();
	}

	_blurAllEditors() {
		return PSA.getInst().blurAllEditors();
	}

	_onClick(evt) {
		this.prohibitMaximizing = false;

		let val = this.txtWdg.getValue();
		if ( !val ) {
			val = "";
		}
		if ( !this.isClk ) {
			return;
		}
		this.isClk = false;

		if ( this._isDrag() ) {
			this.drag = null;
			return;
		}
		if ( evt && this.hasLnk && (val !== "") ) {
			const isShift = evt.isShiftPressed();
			const par = {};
			if ( !isShift ) {
				if ( this._linkActive ) {
					const area = this._clcTxtArea();
					const cx = area.cx;
					const x = area.x;
					let link_clicked = false;
					if ( cx > this.txtWdg.getClientWidth() ) {
						link_clicked = true;
					} else {
						const click_x = evt.getClientX();
						const aln = this.alignment;
						if ( aln === "left" || aln === "inline" ) {
							link_clicked = click_x < (x + cx);
						} else if ( aln === "center" ) {
							link_clicked = (click_x > x) && (click_x < (x + cx));
						} else if ( aln === "right" ) {
							link_clicked = click_x > x;
						}
					}
					if ( link_clicked ) {
						this.cbkWdg.nfySrv(this.wdgId, "clkLnk", par, true);
						this.prohibitMaximizing = true;
					}
				}
			} else {
				let sel = this.txtWdg.getSelection();
				if ( sel && sel.length > 1 ) {
					if ( sel[0] === 0 ) {
						sel[0] = sel[1];
					} else if ( sel[1] === val.length ) {
						sel[1] = sel[0];
					} else {
						sel[0] = sel[1] = Math.min(sel[0], sel[1]);
					}
				} else {
					sel = [ 0, 0 ];
				}
				this.txtWdg.setSelection(sel);
			}
		}
	}

	isAlreadyFocused() {
		const focHis = PSA.getInst().cliCbkWdg.focusHistory;
		if ( focHis.length > 2 && focHis[focHis.length - 1] == focHis[focHis.length - 2] ) {
			return true;
		}
		return false;
	}

	isInTxt(px) {
		let res = false;
		const area = this._clcTxtArea();
		if ( area ) {
			res = (area.x <= px) && (px < (area.x + area.cx));
		}
		return res;
	}

	_onMouseMove(evt) {
		if ( this.hasLnk ) {
			this.setHypLnk(evt.getClientX(), evt.isShiftPressed(), false, null);
		}
	}

	_onMouseLeave(evt) {
		this._mouseDown = false;
	}

	_tryShowExpandButton() {
		this.lastBlur = new Date().getTime();
		const self = this;
		clearTimeout(this.timeout);
		this.timeout = setTimeout(function() {
			if ( new Date().getTime() > self.lastBlur + 300 ) self._showExpandButton();
		}, 320);
	}

	_onBlur(evt) {
		this.curSel = this.txtWdg.getSelection();
		this.lastBlur = new Date().getTime();
		if ( this._hasOverlayDiv() ) {
			this._minimize();
		}
		if ( !!this.expandIco && this.txtWdg._element.lastChild == this.expandIco ) {
			this.txtWdg._element.removeChild(this.expandIco);
			this.expandIco = null;
		}
	}

	_onFocus(evt) {
		const rst = this.inRstSel;
		try {
			this.inRstSel = true;
			if ( this.txtWdg ) {
				this.txtWdg.setSelection(this.curSel);
			}
			this._tryShowExpandButton();
			ScrMen.closeAllMenus();
		} finally {
			this.inRstSel = rst;
		}
	}

	_onSelChange() {
		if ( this.inRstSel ) {
			console.debug("Selection changed!");
			console.debug('>>> in "restore selection"');
		}
		this.curSel = this.txtWdg.getSelection();
	}

	_showExpandButton() {
		if ( !this.expandIco && typeof this.txtWdg == "object" && !!this.txtWdg && this.txtWdg._element ) {
			this.expandIco = document.createElement("div");
			this.expandIco.setAttribute("class", "expand_ico");
			this._updateExpandButton();

			this.expandIco.style.zIndex = "1000";
			const nMargin = this._getScrollBarWidth();
			this.expandIco.style.marginRight = nMargin + "px";
			this.txtWdg._element.appendChild(this.expandIco);

			const self = this;
			this.expandIco.addEventListener("mouseup", function(evt) {
				evt.stopPropagation();
				self._maximize();
			}, this);
			if ( this.txtWdg._element ) {
				this._turnWrapOn(this.txtWdg._element);
			}
		}
	}

	_updateExpandButton() {
		if ( this.expandIco instanceof HTMLElement ) {
			const btn = this.expandIco;
			btn.style.right = this.readOnly ? '1px' : '';
		}
	}

	setHypLnk(pos, shift, offs, down = null) {
		const elm = this.txtWdg._inputElement;
		const foc = this.txtWdg._inputElement === document.activeElement;
		const can_be = !foc;
		let hit = false;
		if ( down !== null ) {
			this._mouseDown = !!down;
		}
		if ( can_be && (pos >= 0) && !shift ) {
			let px = pos;
			if ( offs ) {
				const crs = elm.getClientRects();
				if ( (crs != null) && (crs.length > 0) ) {
					px += crs[0].left;
				}
			}
			hit = this.isInTxt(px);
		}
		if ( hit ) {
			elm.style.cursor = 'pointer';
			elm.style.textDecoration = 'underline';
			this._linkActive = true;
		} else {
			elm.style.cursor = 'auto';
			elm.style.textDecoration = this.txtDco;
			if ( !this._mouseDown && this._linkActive ) {
				this._linkActive = false;
			}
		}
	}

	_clcTxtArea() {
		const area = {};
		const args = this._getArgs();
		const tmp_div = document.createElement('div');
		tmp_div.style.visibility = "hidden";
		tmp_div.style.position = "absolute";
		document.body.appendChild(tmp_div);
		tmp_div.style.fontFamily = args.ffm;
		tmp_div.style.fontSize = args.fsz;
		tmp_div.className = args.css;
		tmp_div.style.fontWeight = args.fwg;
		tmp_div.innerHTML = args.txt;
		area.cx = (tmp_div.clientWidth + 0);
		const input = this.txtWdg._inputElement;
		if ( input instanceof HTMLElement ) {
			const client_rects = input.getClientRects();
			if ( client_rects && client_rects.length > 0 ) {
				const in_rect = client_rects[0];
				area.x = in_rect.left;
				if ( "right" === this.alignment ) {
					area.x = in_rect.right - area.cx;
				} else if ( "center" === this.alignment ) {
					area.x = in_rect.left + (in_rect.width - area.cx) / 2;
				}
			} else {
				area.x = 0;
			}
		}
		tmp_div.parentNode.removeChild(tmp_div);
		return area;
	}

	_getArgs() {
		const args = {};
		const val = this.txtWdg.getValue();
		if ( val && (val.length > 0) ) {
			args.fsz = this.txtWdg._inputElement.style.fontSize;
			args.fst = this.txtWdg._inputElement.style.fontStyle;
			args.mrg = this.txtWdg._inputElement.style.margin;
			args.ffm = this.txtWdg._inputElement.style.fontFamily;
			args.fwg = this.txtWdg._inputElement.style.fontWeight;
			args.css = this.txtWdg._inputElement.className;
			args.txt = val;
			args.idw = this.wdgId;
			args["pisasales.CSTPRP.IDW"] = this.wdgId;
		}
		return args;
	}

	_getScrollBarWidth() {
		if ( !!this.txtWdg ) {
			const textArea = this.txtWdg._element.getElementsByTagName("textarea")[0];
			if ( !!textArea ) {
				return (textArea.style.height.replace("px", "") < textArea.scrollHeight) ? 15 : 0;
			}
		}
		return 0;
	}

	_turnWrapOn(element) {
		if ( element && element.classList.contains("rchTxt", "minimized") ) {
			const textArea = this.txtWdg._element.getElementsByTagName("textarea")[0];
			if ( !!textArea ) {
				textArea.setAttribute("wrap", "on");
			}
		}
	}

	_blockKeyHandling(max) {
		this.cbkWdg.nfySrv(this.wdgId, "max", max, false);
		PSA.getInst().keyHdl.blockGlobalKeyHandling(max);
	}
}
